import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';
import DealService from '../../api/services/DealService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
var imageUrl = process.env.REACT_APP_LARAVEL_Deal_IMAGE_URL;
const Deal = () => {
    const [Deal, setDeal] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = Deal.slice(firstIndex, lastIndex);
    const npage = Math.ceil(Deal.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    const [isLoading, setisloading] = useState(true);
    useEffect(() => {
        getDeal();
    }, []);

    const getDeal = async () => {
        try {
            let Deal = await DealService.index().json();
            setDeal(Deal.data);
            setisloading(false);
        } catch (error) {
            console.log(error);
        }
    };
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    function changeCPage(id) {
        setCurrentPage(id);
    }

    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
    const deleteDeal = async (id) => {

        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this data!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                let responseData = await DealService.destroy(id).json();
                if (responseData.status === true) {
                    getDeal();
                }
                swal("Your Deal has been deleted successfully!", {
                    icon: "success",
                });

            }
        }).catch(() => {
            swal("Your Deal is safe!");
        });
    }
    return (
        <>
            <MainPagetitle mainTitle="Deal" pageTitle={'Deal'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Deal</h4>
                                        <div>
                                            <Link to={`/admin/add_deal/`} className="btn btn-primary btn-sm ms-1">+ Add Deal</Link> {" "}
                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>Title</th>
                                                    <th>Sub Title</th>
                                                    <th>Logo</th>
                                                    <th>Feature Image</th>
                                                    <th className="d-flex">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {records.map((item, index) => (
                                                    <tr key={index}>
                                                        <td><span>{index + 1}</span></td>
                                                        <td>
                                                            <div className="products">
                                                                <div>
                                                                    <h6>{item.title}</h6>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="products">
                                                                <div>
                                                                    <h6>{item.sub_title}</h6>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>

                                                            <img className="img-drop-area" height={100} width={100} src={imageUrl + item.logo} alt='icon' />
                                                        </td>
                                                        <td><img className="img-drop-area" height={100} width={100} src={imageUrl + item.feature_image} alt='smallicon' /></td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <Link
                                                                    to={`/admin/edit_deal/${item.id}`}
                                                                    className="btn btn-primary shadow btn-xs sharp me-1"
                                                                >
                                                                    <i className="fas fa-pencil-alt"></i>
                                                                </Link>
                                                                <Link
                                                                    onClick={() =>
                                                                        deleteDeal(item.id)
                                                                    }

                                                                    className="btn btn-danger shadow btn-xs sharp"
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </Link>
                                                                {/* <Button className="btn btn-danger shadow btn-xs sharp" onClick={()=>deleteDeal(item.id)} 
                                                                >
                                                                <i className="fa fa-trash"></i>
                                                                </Button> */}
                                                            </div>
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {Deal.length < lastIndex ? Deal.length : lastIndex}
                                                {" "}of {Deal.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default Deal;